import { COLORS } from "@/comiq/tokens";

// Shared section-header card rendered IDENTICALLY by the admin "Pratinjau Responden"
// and the live respondent flow (/s/:token). Each field is independent: shown only when
// it holds non-whitespace text, hidden when empty. If every field is empty, nothing
// renders (no placeholder, no empty white bar). Never injects fallback text.
const has = (v) => Boolean((v || "").trim());

export const SectionHeader = ({ label, title, description, instruction, sectionCode, testPrefix = "" }) => {
  if (![label, title, description, instruction].some(has)) return null;
  return (
    <div
      className="mb-6 rounded-comiq border px-4 py-3"
      style={{ borderColor: COLORS.line, background: COLORS.surfaceAlt }}
      data-testid={`${testPrefix}section-${sectionCode || "x"}`}
    >
      {has(label) && (
        <div className="text-xs font-semibold uppercase tracking-wide" style={{ color: COLORS.orangeInk }} data-testid={`${testPrefix}section-label`}>{label}</div>
      )}
      {has(title) && (
        <div className="mt-1 text-base font-semibold" style={{ color: COLORS.ink }} data-testid={`${testPrefix}section-title`}>{title}</div>
      )}
      {has(description) && (
        <p className="mt-0.5 text-sm" style={{ color: COLORS.textSoft }} data-testid={`${testPrefix}section-desc`}>{description}</p>
      )}
      {has(instruction) && (
        <p className="mt-1 text-sm italic" style={{ color: COLORS.textSoft }} data-testid={`${testPrefix}section-instruction`}>{instruction}</p>
      )}
    </div>
  );
};

// Block prompt renders independently of the section header (shown even when the
// header is empty). Returns null when there is no non-whitespace prompt.
export const BlockPrompt = ({ prompt, testPrefix = "" }) => {
  if (!has(prompt)) return null;
  return (
    <p className="mt-3 text-sm font-medium" style={{ color: COLORS.textSoft, lineHeight: 1.6 }} data-testid={`${testPrefix}group-prompt`}>{prompt}</p>
  );
};
